import { useLayoutEffect, useRef } from 'react'

export const useSelectpicker = (dependencies?: unknown[]): React.RefObject<HTMLSelectElement> => {
  const selectElement = useRef<HTMLSelectElement>(null)
  useLayoutEffect(() => {
    if (selectElement.current && $.fn.selectpicker) {
      $(selectElement.current).selectpicker()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencies)
  return selectElement
}
